/* eslint-disable camelcase */
export default {
  unknown_error: "Неизвестная ошибка при получении журнала транзакций!",
};
